module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-22.e173d3fa.png";